<script>
import VirtualList from '@/components/vue3/VirtualList/VirtualList'

export default {
  name: 'InfiniteFlexTable',

  components: {
    // DynamicScroller,
    // DynamicScrollerItem,
    VirtualList,
  },
  props: {
    tHead: [Array, Object],
    tRows: { default: () => [] },
    sortOrder: { default: () => 'desc' },
    sortKey: [String, Number],
  },
  emits: ['th:click', 'visible', 'tr:click', 'scroll'],
  data() {
    return {}
  },
  methods: {
    thClick(item, index) {
      this.$emit('th:click', { item, index })
    },
    handleVisible() {
      this.$emit('visible')
    },
    handleScroll(e) {
      const scroller = this.$refs.scroller?.$el
      if (scroller) {
        this.$emit('scroll', { e, scroller })
      }
    },
  },
}
</script>

<template>
  <div class="inftable">
    <slot name="before" />
    <div class="inftable_row inftable_head">
      <slot name="thead_prev"></slot>
      <div
        v-for="(th, idx) in tHead"
        :key="th.id"
        class="inftable_th"
        :class="[
          `inftable_th_${th.id}`,
          `${
            sortKey.toString() === idx.toString() ? `inftable_sort inftable_sort_${sortOrder}` : ''
          }`,
        ]"
        @click="thClick(th, idx)"
      >
        <slot :name="`th_${idx}`">
          <span class="inftable_th_text">
            {{ th.name }}
          </span>
        </slot>
        <i
          v-if="th.hasSort"
          class="inftable_sort_icon icon_btn mdi mdi-arrow-down"
        ></i>
      </div>
    </div>

    <VirtualList
      ref="scroller"
      class="inftable_body inftable_scroller no-scroll-track"
      :hasDynamicSize="true"
      :items="tRows"
      :estimateSize="20"
      :itemSize="20"
      idKey="id"
      :keeps="50"
      @scroll="handleScroll"
      @visible="handleVisible"
    >
      <template #item="{ item, index }">
        <slot
          name="tRow"
          :row="item"
          :sortKey="sortKey.toString()"
          :sortOrder="sortOrder"
          :index="index"
          :tHead="tHead"
        >
        </slot>
      </template>
    </VirtualList>
  </div>
</template>

<style lang="scss">
.inftable {
  --clr-back: transparent;
  --clr-body-back: transparent;
  --body-height: auto;
  --body-min-height: 0;
  --body-max-height: 100vh;
  // --body-max-height: auto;
  // --body-max-height: 33rem;

  --clr-row-back: transparent;
  --clr-row-back-hover: var(--clr-black-3);
  --clr-row-back-active: var(--clr-black-4);
  // --row-height: calc(2em + 2px);
  --row-height: 2em;

  --th-font-size: 0.875em;
  --th-font-weight: 600;
  --th-padding: 0 0.5em;
  --clr-th: var(--clr-white-0);
  --clr-th-back: transparent;
  --clr-th-border: transparent;
  --clr-th-border-hover: var(--clr-black-3);
  --clr-th-border-active: var(--clr-black-3);
  --clr-th-back-hover: var(--clr-black-2);
  --clr-th-back-active: var(--clr-black-2);

  --sort-icon-opacity: 0;
  --sort-icon-position: absolute;
  --sort-icon-font-size: 0.8em;
  --sort-icon-padding: 0.125em;
  --sort-icon-margin: 0;
  --sort-icon-right: 0.25em;
  --sort-icon-top: auto;

  --td-font-size: 1em;
  --td-font-weight: 400;
  --td-padding: 0 0.5em;
  --clr-td: var(--clr-white-0);
  --clr-td-back: transparent;

  --clr-body-row-back: var(--clr-black-1-2);
  --clr-body-row-hover: var(--clr-black-3);
  --clr-body-row-active: var(--clr-black-4);

  --clr-td-back-active: var(--clr-black-2);

  display: flex;
  flex-direction: column;
  background: var(--clr-back);
  &_row {
    display: flex;
    width: 100%;
    background: var(--clr-row-back);
    height: var(--row-height);
    // border-bottom: 2px solid var(--clr-black-1);
    border-bottom: 1px solid var(--clr-black-1);
    overflow: hidden;
    flex-shrink: 0;
  }
  &_head {
    z-index: 2;
    &.inftable_row {
      overflow: unset;
    }
  }
  &_body {
    background: var(--clr-body-back);
    height: var(--body-height);
    min-height: var(--body-min-height);
    max-height: var(--body-max-height);
    overflow: auto;
    border-radius: 4px;
    &_row {
      z-index: 1;
      .inftable_td {
        --clr-td-back: var(--clr-body-row-back);
        &_active {
          --clr-td-back: var(--clr-td-back-active);
        }
      }
      &:hover {
        cursor: pointer;
        z-index: 2;
        .inftable_td {
          --clr-td-back: var(--clr-body-row-hover);
        }
      }
      &_active {
        .inftable_td {
          --clr-td-back: var(--clr-body-row-active);
        }
      }
    }
  }

  &_th,
  &_td {
    min-width: 0;
  }
  &_th {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    color: var(--clr-th);
    background: var(--clr-th-back);
    padding: var(--th-padding);
    border-radius: 4px;
    z-index: 2;
    &_text {
      font-size: var(--th-font-size);
      font-weight: var(--th-font-weight);
      line-height: 1;
    }
    &:hover {
      cursor: pointer;
      --sort-icon-opacity: 1;
      --clr-th-back: var(--clr-th-back-hover);
    }
  }
  &_sort {
    --clr-th-back: var(--clr-th-back-active);
    --sort-icon-opacity: 1;
    &_icon {
      position: var(--sort-icon-position) !important;
      right: var(--sort-icon-right);
      top: var(--sort-icon-top);
      border-radius: 50%;
      transition: 0.22s;
      font-size: var(--sort-icon-font-size);
      opacity: var(--sort-icon-opacity);
      padding: var(--sort-icon-padding);
      margin: var(--sort-icon-margin);
      z-index: 2;
    }
    &_desc {
      .inftable_sort_icon {
        transform: rotate(180deg);
      }
    }
  }

  &_td {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 3;
    color: var(--clr-td);
    font-size: var(--td-font-size);
    font-weight: var(--td-font-weight);
    background: var(--clr-td-back);
    padding: var(--td-padding);
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>
